import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    mortgageClauseCpl: {
      inputType: 'select',
      title: 'Mortgage Clause CPL',
      options: {},
      hasDefaultOption: true,
      sort: true,
      sortKey: 'value',
    },
    mortgageClauseInsurance: {
      inputType: 'select',
      title: 'Mortgage Clause Insurance',
      options: {},
      hasDefaultOption: true,
      sort: true,
      sortKey: 'value',
    },
    insuranceCompany: {
      inputType: 'radio',
      options: ['Hazard Insurance Company', 'Hazard Insurance Company 2'],
      title: 'Insurance Company Type',
      value: '',
    },
  }
}
